module.exports = __webpack_public_path__ + "img/brochures and flyers.e6ddb910.svg";